
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"x1":"100%","y1":"50%","x2":"0%","y2":"50%","id":"id-62a"}},[_c('stop',{attrs:{"stop-color":"#FFF","stop-opacity":"0","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#FFF","offset":"100%"}})])]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"url(#id-62a)","d":"M15 12L3 19V5z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M21 12L9 19V5z"}})])])
          )
        }
      }
    